/**
 * Minimalist sub-collection menu: Swiper + fit/overflow alignment + desktop nav.
 */
(function () {
  if (window.__subCollectionsMenuInit) return;
  window.__subCollectionsMenuInit = true;

  var DESKTOP_MQ = window.matchMedia('(min-width: 768px)');

  function isB2BUser() {
    return window.__USER_TYPE__ === 'b2b';
  }

  function shouldHideMenuForB2B(config) {
    if (!config || !config.hiddenHandles || !config.hiddenHandles.length) return false;
    if (config.serverHide) return true;

    var hidden = config.hiddenHandles;
    if (hidden.indexOf(config.currentHandle) !== -1) return true;

    if (!config.menuHandles || !config.menuHandles.length) return false;

    return config.menuHandles.some(function (handle) {
      return hidden.indexOf(handle) !== -1;
    });
  }

  function hideB2BSubCollectionMenus() {
    if (!isB2BUser()) return;

    document.querySelectorAll('[id^="sub-collections-b2b-config-"]').forEach(function (script) {
      var config;
      try {
        config = JSON.parse(script.textContent);
      } catch (error) {
        return;
      }

      if (!shouldHideMenuForB2B(config)) return;

      var section = script.closest('.shopify-section');
      if (!section) return;

      var pageWidth = section.querySelector('.page-width--minimalist, .page-width');
      if (pageWidth) {
        pageWidth.style.display = 'none';
        return;
      }

      var menu = section.querySelector('.sub-collection-menu, .sub-collection-wrappr--minimalist');
      if (menu) menu.style.display = 'none';
    });
  }

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  function getMenuWrap(scroller) {
    return scroller.closest('[data-sub-collection-menu]');
  }

  function updateMinimalistMenuAlignment(scroller) {
    var wrapper = scroller.classList.contains('swiper')
      ? scroller.querySelector('.swiper-wrapper')
      : scroller;
    if (!wrapper) return;

    var menuWrap = getMenuWrap(scroller);
    var slideCount = scroller.querySelectorAll('.swiper-slide').length;
    var images = scroller.querySelectorAll('img');
    var imagesReady = true;

    images.forEach(function (img) {
      if (!img.complete) imagesReady = false;
    });

    var overflows = wrapper.scrollWidth > scroller.clientWidth + 2;

    if (!imagesReady && slideCount > 1) {
      overflows = true;
    }

    scroller.classList.toggle('is-content-fitted', !overflows);
    scroller.classList.toggle('is-content-overflowing', overflows);

    if (menuWrap) {
      menuWrap.classList.toggle('is-scrollable', overflows);
    }

    if (scroller.swiper) {
      scroller.swiper.allowTouchMove = overflows;
      scroller.swiper.params.simulateTouch = overflows;
      if (!overflows) {
        scroller.swiper.slideTo(0, 0);
        scroller.swiper.setTranslate(0);
      }
      scroller.swiper.update();
      updateMenuNavState(scroller.swiper);
    }
  }

  function updateMenuNavState(swiperInstance) {
    if (!swiperInstance || !swiperInstance.el) return;
    var menuWrap = getMenuWrap(swiperInstance.el);
    if (!menuWrap) return;

    var overflows = menuWrap.classList.contains('is-scrollable');
    var showNav = overflows && isDesktop();

    menuWrap.classList.toggle('has-visible-nav', showNav);

    if (!showNav) return;

    var prev = menuWrap.querySelector('.sub-collection-menu__nav--prev');
    var next = menuWrap.querySelector('.sub-collection-menu__nav--next');
    var atStart = Math.abs(swiperInstance.translate - swiperInstance.minTranslate()) < 2;
    var atEnd = Math.abs(swiperInstance.translate - swiperInstance.maxTranslate()) < 2;

    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  function bindMinimalistAlignment(scroller) {
    updateMinimalistMenuAlignment(scroller);

    if (scroller.dataset.alignmentBound === 'true') return;
    scroller.dataset.alignmentBound = 'true';

    scroller.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        updateMinimalistMenuAlignment(scroller);
      });
      img.addEventListener('error', function () {
        updateMinimalistMenuAlignment(scroller);
      });
    });

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(function () {
        updateMinimalistMenuAlignment(scroller);
      });
      resizeObserver.observe(scroller);
      var wrapper = scroller.querySelector('.swiper-wrapper');
      if (wrapper) resizeObserver.observe(wrapper);
    }

    window.addEventListener('resize', function () {
      updateMinimalistMenuAlignment(scroller);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        updateMinimalistMenuAlignment(scroller);
      });
    }
  }

  function initMinimalistSwiper(scroller) {
    if (typeof Swiper === 'undefined') return false;
    if (scroller.swiper) return true;

    var menuWrap = getMenuWrap(scroller);
    var prevEl = menuWrap ? menuWrap.querySelector('.sub-collection-menu__nav--prev') : null;
    var nextEl = menuWrap ? menuWrap.querySelector('.sub-collection-menu__nav--next') : null;

    new Swiper(scroller, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: {
        enabled: true,
        momentum: true,
        momentumRatio: 0.5,
      },
      grabCursor: true,
      watchOverflow: true,
      resistanceRatio: 0.65,
      threshold: 8,
      preventClicks: true,
      preventClicksPropagation: true,
      navigation:
        prevEl && nextEl
          ? {
              prevEl: prevEl,
              nextEl: nextEl,
            }
          : undefined,
      on: {
        init: function (swiper) {
          bindMinimalistAlignment(scroller);
          updateMenuNavState(swiper);
        },
        resize: function (swiper) {
          updateMinimalistMenuAlignment(scroller);
          updateMenuNavState(swiper);
        },
        slideChange: function (swiper) {
          updateMenuNavState(swiper);
        },
        reachBeginning: function (swiper) {
          updateMenuNavState(swiper);
        },
        reachEnd: function (swiper) {
          updateMenuNavState(swiper);
        },
        fromEdge: function (swiper) {
          updateMenuNavState(swiper);
        },
        sliderMove: function (swiper) {
          updateMenuNavState(swiper);
        },
        touchEnd: function (swiper) {
          updateMenuNavState(swiper);
        },
      },
    });

    return true;
  }

  function boot() {
    hideB2BSubCollectionMenus();

    document
      .querySelectorAll('.sub-collection-wrappr--minimalist:not(.swiper)')
      .forEach(bindMinimalistAlignment);

    var swipers = document.querySelectorAll('.sub-collection-wrappr--minimalist.swiper');
    if (!swipers.length) return;

    if (typeof Swiper === 'undefined') {
      window.setTimeout(boot, 30);
      return;
    }

    swipers.forEach(function (el) {
      initMinimalistSwiper(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  DESKTOP_MQ.addEventListener('change', function () {
    document
      .querySelectorAll('.sub-collection-wrappr--minimalist.swiper')
      .forEach(function (el) {
        if (el.swiper) updateMenuNavState(el.swiper);
      });
  });
})();
